(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breadcrumbs"]) return;
  try {
    
(function () {
      var wrapper = document.querySelector('[data-bc-wrapper]');
      var PAGE_TYPE = wrapper ? wrapper.getAttribute('data-page-type') : "";

      var HUBS = [
        { url: "/pages/makskeresanas-preces", title: "Makšķerēšanas preces" },
        { url: "/collections/laivas-un-aprikojums", title: "Laivas un aprīkojums" },
        { url: "/pages/turisma-inventars", title: "Tūrisma inventārs" }
      ];

      // Read real hub URLs from navigation, including Apģērbs.
      var hubTitles = {
        "makšķerēšanas preces": "Makšķerēšanas preces",
        "laivas un aprīkojums": "Laivas un aprīkojums",
        "apģērbs": "Apģērbs",
        "tūrisms": "Tūrisms",
        "tūrisma inventārs": "Tūrisma inventārs"
      };
      document.querySelectorAll('header a[href], .section-header a[href]').forEach(function (a) {
        var label = (a.textContent || '').trim().replace(/\s+/g, ' ').toLocaleLowerCase('lv');
        if (!hubTitles[label]) return;
        try {
          var u = new URL(a.href, location.origin);
          if (u.origin !== location.origin) return;
          if (!HUBS.some(function (h) { return h.url === u.pathname; })) {
            HUBS.push({url: u.pathname, title: hubTitles[label]});
          }
        } catch (e) {}
      });

      var KEY_HUB = "breadcrumb_last_hub";
      var KEY_CHAIN = "breadcrumb_collection_chain";
      var MAX_CHAIN = 5;

      function safeJSONParse(str) { try { return JSON.parse(str); } catch (e) { return null; } }
      function sameOrigin(ref) {
        try { return new URL(ref, window.location.origin).origin === window.location.origin; }
        catch(e){ return false; }
      }
      function findHub(path) {
        for (var i=0;i<HUBS.length;i++) if (HUBS[i].url === path) return HUBS[i];
        return null;
      }

      function saveHub(hub) {
        if (!hub || !hub.url || !hub.title) return;
        try { localStorage.setItem(KEY_HUB, JSON.stringify({ url: hub.url, title: hub.title, ts: Date.now() })); } catch(e){}
      }
      function readHub() {
        try {
          var d = safeJSONParse(localStorage.getItem(KEY_HUB));
          if (!d || !d.url || !d.title) return null;
          return d;
        } catch(e){ return null; }
      }

      function saveChain(chain) {
        try { localStorage.setItem(KEY_CHAIN, JSON.stringify(chain)); } catch(e){}
      }
      function readChain() {
        try {
          var c = safeJSONParse(localStorage.getItem(KEY_CHAIN));
          return Array.isArray(c) ? c : [];
        } catch(e){ return []; }
      }

      function addToChain(col) {
        if (!col || !col.url || !col.title) return;
        var chain = readChain();
        
        // Pārbaudām vai kolekcija jau ir ķēdē
        var existingIndex = -1;
        for (var i=0; i<chain.length; i++) {
          if (chain[i].url === col.url) {
            existingIndex = i;
            break;
          }
        }
        
        if (existingIndex >= 0) {
          // Ja atgriežamies uz vecāku kolekciju, nodzēšam visu pēc tās
          chain = chain.slice(0, existingIndex + 1);
        } else {
          // Jauna kolekcija - pievienojam beigās
          chain.push({ url: col.url, title: col.title });
          if (chain.length > MAX_CHAIN) {
            chain = chain.slice(-MAX_CHAIN);
          }
        }
        
        saveChain(chain);
      }

      function resetChain() {
        saveChain([]);
      }

      // Hub switches must also work on pages without a breadcrumb.
      document.addEventListener('click', function (event) {
        var a = event.target.closest('a[href]');
        if (!a) return;
        try {
          var u = new URL(a.href, location.origin);
          if (u.origin !== location.origin) return;
          var hub = findHub(u.pathname);
          if (hub) { saveHub(hub); resetChain(); }
        } catch (e) {}
      });

      // HUB: current page > referrer > stored
      var currentPath = window.location.pathname;
      var currentHub = findHub(currentPath);
      if (currentHub) {
        saveHub(currentHub);
        resetChain();
      }

      var ref = document.referrer || "";
      if (!currentHub && ref && sameOrigin(ref)) {
        try {
          var refPath = new URL(ref).pathname;
          var refHub = findHub(refPath);
          if (refHub) {
            saveHub(refHub);
            resetChain();
          }
        } catch(e){}
      }

      var hubToUse = currentHub || readHub();

      if (!wrapper) return;

      var hubLink = document.querySelector(".breadcrumb-hub-link");
      if (hubLink) {
        if (hubToUse && hubToUse.url && hubToUse.title) {
          hubLink.textContent = hubToUse.title;
          hubLink.setAttribute("href", hubToUse.url);
        } else {
          hubLink.textContent = hubLink.getAttribute("data-fallback-title") || "Kolekcijas";
          hubLink.setAttribute("href", hubLink.getAttribute("data-fallback-url") || "/collections");
        }
      }

      // COLLECTION: saglabā ķēdē
      if (PAGE_TYPE === "collection") {
        var colUrl = wrapper.getAttribute("data-current-collection-url") || "";
        var colTitle = wrapper.getAttribute("data-current-collection-title") || "";
        
        if (!hubToUse || hubToUse.url !== colUrl) {
          addToChain({ url: colUrl, title: colTitle });
        }

        var chain = readChain();
        var chainContainer = document.querySelector(".breadcrumb-chain-container");
        var chainSep = document.querySelector(".bc-chain-sep");
        
        if (chain.length > 0 && chainContainer) {
          var html = "";
          for (var i=0; i<chain.length - 1; i++) {
            html += '<a href="' + chain[i].url + '" class="breadcrumb-link bc-chain-link" data-chain-index="' + i + '">' + chain[i].title + '</a>';
            if (i < chain.length - 2) html += '<span class="breadcrumb-separator">/</span>';
          }
          chainContainer.innerHTML = html;
          if (chainSep && html) chainSep.style.display = "";
          
          // Pievienojam click event listeners
          var chainLinks = document.querySelectorAll(".bc-chain-link");
          for (var j=0; j<chainLinks.length; j++) {
            chainLinks[j].addEventListener("click", function(e) {
              var index = parseInt(this.getAttribute("data-chain-index"));
              var currentChain = readChain();
              var newChain = currentChain.slice(0, index + 1);
              saveChain(newChain);
            });
          }
        }

        if (hubToUse && hubToUse.url === colUrl) {
          var sep = document.querySelector(".bc-collection-sep");
          var cur = document.querySelector(".bc-collection-current");
          if (sep) sep.style.display = "none";
          if (cur) cur.style.display = "none";
        }
        return;
      }

      // PRODUCT
      if (PAGE_TYPE === "product") {
        var link = document.querySelector(".breadcrumb-collection-link");
        var sep  = document.querySelector(".bc-collection-sep");
        if (!link) return;

        var contextTitle = (link.getAttribute("data-context-title") || "").trim();
        var contextUrl   = (link.getAttribute("data-context-url") || "").trim();

        var finalTitle = "";
        var finalUrl = "";

        if (contextTitle && contextUrl) {
          finalTitle = contextTitle;
          finalUrl = contextUrl;
        } else {
          finalTitle = (link.getAttribute("data-fallback-title") || "").trim();
          finalUrl = (link.getAttribute("data-fallback-url") || "").trim();
        }

        var chain = readChain();
        var chainContainer = document.querySelector(".breadcrumb-chain-container");
        var chainSep = document.querySelector(".bc-chain-sep");
        
        if (chain.length > 0 && chainContainer) {
          var html = "";
          for (var i=0; i<chain.length; i++) {
            if (chain[i].url === finalUrl) continue;
            html += '<a href="' + chain[i].url + '" class="breadcrumb-link bc-chain-link" data-chain-index="' + i + '">' + chain[i].title + '</a>';
            html += '<span class="breadcrumb-separator">/</span>';
          }
          chainContainer.innerHTML = html;
          if (chainSep && html) chainSep.style.display = "";
          
          // Click events
          var chainLinks = document.querySelectorAll(".bc-chain-link");
          for (var j=0; j<chainLinks.length; j++) {
            chainLinks[j].addEventListener("click", function(e) {
              var index = parseInt(this.getAttribute("data-chain-index"));
              var currentChain = readChain();
              var newChain = currentChain.slice(0, index + 1);
              saveChain(newChain);
            });
          }
        }

        if (finalTitle && finalUrl && finalUrl !== "#") {
          link.textContent = finalTitle;
          link.setAttribute("href", finalUrl);
        } else {
          if (sep) sep.style.display = "none";
          link.style.display = "none";
        }

        try {
          var colHref = link.getAttribute("href");
          if (hubToUse && hubToUse.url && colHref && hubToUse.url === colHref) {
            if (sep) sep.style.display = "none";
            link.style.display = "none";
          }
        } catch(e){}
      }
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
